import { useParams } from 'react-router';

import { usePhotos } from '@/hooks/usePhotos';
import { useUsers } from '@/hooks/useUsers';
import { Photo } from '@/lib/Photo';
import { Photos } from '@/lib/Photos';
import { User } from '@/lib/User';

export type RoutePhotoState = {
  photo: Photo | null;
  done: boolean;
};

export const useRoutePhoto = (): RoutePhotoState => {
  const { photoId } = useParams();
  const { photos: photoData } = usePhotos();
  const { users } = useUsers();

  if (!photoId) {
    return { photo: null, done: true };
  }

  // Convert PhotoData to Photo instances and assign user data
  const photoInstances = photoData.map(data => {
    const photo = Photo.fromApi(data);
    const user = users.find(u => u.id.toString() === data.user_id.toString());
    if (user) {
      photo.user = User.fromApi(user);
    }
    return photo;
  });
  const photos = new Photos(photoInstances);

  const photo = photos.getPhotoById(photoId);

  if (!photo) {
    return { photo: null, done: true };
  }

  return { photo, done: true };
}

export default useRoutePhoto;
